<template>
  <div class="flex justify-between h-full items-center px-5">
    <router-link
      to="/"
      :class="activePage('assignments') ? 'text-white' : 'text-gray-400'"
      class="flex active flex-col cursor-pointer transition-transform duration-300 transform hover:scale-105"
    >
      <db-icon
        icon="more-vertical"
        variant="32-outline"
        class="hydrated"
      ></db-icon>
      <p>{{ $t("main.assignments") }}</p>
    </router-link>
    <router-link
      to="/tour"
      :class="activePage('tour') ? 'text-white' : 'text-gray-400'"
      class="flex flex-col cursor-pointer transition-transform duration-300 transform hover:scale-105"
    >
      <db-icon
        icon="round-trip"
        variant="32-outline"
        class="hydrated"
      ></db-icon>
      <p>{{ $t("main.tour") }}</p>
    </router-link>
    <router-link
      to="/done"
      :class="activePage('done') ? 'text-white' : 'text-gray-400'"
      class="flex flex-col cursor-pointer transition-transform duration-300 transform hover:scale-105"
    >
      <db-icon
        icon="check-circle"
        variant="32-outline"
        class="hydrated"
      ></db-icon>
      <p>{{ $t("main.completed") }}</p>
    </router-link>
  </div>
</template>
<script setup lang="ts">
import { useRoute } from "vue-router";
import { DbIcon } from "@db-ui/v-elements-enterprise/dist/components";
// TODO - change done icon back to check-circle

const route = useRoute();

const activePage = (page) => {
  return route.name === page;
};
</script>
